import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplatesMutation, InsertTemplatesMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplatesDocument } from '@/graphql/generated/graphql';
export type TemplateInsertInput = {
  OrganizationIds?: string[]
  Slug?: string
  Title?: string
  Description?: string
  Icon?: string
  Available?: boolean
  Popular?: boolean
  Href?: string
  EstimatedMinutes?: number
  SystemPrompt?: string
  SystemPromptRole?: string
  UilmDescriptionKey?: string
  UilmTitleKey?: string
  PreviewToken?: string
  Keywords?: string[]
  Category?: string
  Kind?: string
}

export type InsertTemplateResponse = {
  data: {
    insertTemplates: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplate = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template'],
    mutationFn: (variables: TemplateInsertInput) => {
      return graphqlClient.request<InsertTemplatesMutation>(InsertTemplatesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplate: mutation.mutate,
    insertTemplateAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_MUTATION = InsertTemplatesDocument;
